import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

import { LoadingSplash } from "@components/LoadingSplash";

import { BlockItem } from "./BlockItem";
import { InitialPlayer } from "./InitialPlayer";

const GlobalStyle = createGlobalStyle`
  #root, body {
    overflow: auto;
    background-color: black;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: black;
  color: white;
`;

const AdsLayout = styled.div`
  position: relative;
  width: ${({ width = "600" }) => width}px;
  height: ${({ height = "600" }) => height}px;
  box-sizing: border-box;
`;

export default () => {
  const [isReady, setIsReady] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [campaignElapsedTime, setCampaignElapsedTime] = useState(0);
  const [currentCampaignIndex, setCurrentCampaignIndex] = useState(0);
  const intervalRef = useRef(null);
  const [playCampaignCount, setPlayCampaignCount] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [filteredCampaigns, setFilteredCampaigns] = useState([]);
  const filterIntervalRef = useRef(null);

  const currentCampaign = _.get(filteredCampaigns, [currentCampaignIndex]);

  const initData = async () => {
    const resp = {
      status: true,
      result: {
        respCampaignList: [
          {
            id: 1,
            category_customer_id: 1,
            location_id: 1,
            name: "TENT (1) - CAMPAIGN (1)",
            start_date: "2024-07-01",
            end_date: "2024-08-31",
            start_time: "00:00:00",
            end_time: "23:00:00",
            width: "400",
            height: "400",
            days_of_week: {
              sun: "true",
              mon: "true",
              tue: "true",
              wed: "true",
              thu: "true",
              fri: "true",
              sat: "true",
            },
            status: "ON-AIR",
            created_at: "2024-07-11 02:16:24",
            updated_at: "2024-07-11 02:16:24",
            adsBlocks: [
              {
                id: 3,
                advertising_campaign_id: 1,
                block_key: "efec1381-d7f4-4fea-96f8-89063db98077",
                name: "BLOCK-1",
                width: "400",
                height: "400",
                position_x: "0",
                position_y: "0",
                created_at: "2024-07-11 02:18:51",
                updated_at: "2024-07-11 02:18:51",
                blockMedias: [
                  {
                    id: 5,
                    ads_block_id: 3,
                    type: "image",
                    is_use_media_in_project: true,
                    media_id: 2,
                    duration: 15,
                    attribute: {
                      objectFit: "contain",
                      path: "uploads/medias/customer_1/location_1/5f424aa0-9d15-46e9-9974-ab0d9cfad6d7.png",
                    },
                    created_at: "2024-07-11 02:18:51",
                    updated_at: "2024-07-11 02:18:51",
                  },
                  {
                    id: 6,
                    ads_block_id: 3,
                    type: "image",
                    is_use_media_in_project: true,
                    media_id: 1,
                    duration: 15,
                    attribute: {
                      objectFit: "contain",
                      path: "uploads/medias/customer_1/location_1/4e78ba2b-20e4-4667-a7e2-1286e3a4f494.png",
                    },
                    created_at: "2024-07-11 02:18:51",
                    updated_at: "2024-07-11 02:18:51",
                  },
                ],
              },
            ],
            max_duration: 30,
          },
          {
            id: 2,
            category_customer_id: 1,
            location_id: 1,
            name: "TENT (1) - CAMPAIGN (2)",
            start_date: "2024-07-01",
            end_date: "2024-08-31",
            start_time: "00:00:00",
            end_time: "23:00:00",
            width: "400",
            height: "400",
            days_of_week: {
              sun: "true",
              mon: "true",
              tue: "true",
              wed: "true",
              thu: "true",
              fri: "true",
              sat: "true",
            },
            status: "ON-AIR",
            created_at: "2024-07-11 02:16:41",
            updated_at: "2024-07-11 02:16:41",
            adsBlocks: [
              {
                id: 5,
                advertising_campaign_id: 2,
                block_key: "0c227f06-2086-4aa3-8c4f-2d206d9eeb39",
                name: "BLOCK-1",
                width: "400",
                height: "400",
                position_x: "0",
                position_y: "0",
                created_at: "2024-07-11 03:21:21",
                updated_at: "2024-07-11 03:21:21",
                blockMedias: [
                  {
                    id: 8,
                    ads_block_id: 5,
                    type: "running-text",
                    is_use_media_in_project: false,
                    media_id: null,
                    duration: 15,
                    attribute: {
                      text: "TENT",
                      direction: "left",
                      fontSize: "16px",
                      color: "#ffffff",
                      speed: "10",
                      fontFamily: "IBM Plex Sans Thai",
                      backgroundColor: "#000000",
                    },
                    created_at: "2024-07-11 03:21:21",
                    updated_at: "2024-07-11 03:21:21",
                  },
                  {
                    id: 3,
                    ads_block_id: 5,
                    type: "image",
                    is_use_media_in_project: true,
                    media_id: 4,
                    duration: 15,
                    attribute: {
                      objectFit: "contain",
                      path: "uploads/medias/customer_1/location_1/ccb82a6a-fdae-45df-b096-b5c11cca65c9.jpeg",
                    },
                    created_at: "2024-07-11 03:21:21",
                    updated_at: "2024-07-11 03:21:21",
                  },
                  {
                    id: 4,
                    ads_block_id: 5,
                    type: "image",
                    is_use_media_in_project: true,
                    media_id: 3,
                    duration: 15,
                    attribute: {
                      objectFit: "contain",
                      path: "uploads/medias/customer_1/location_1/b26b7337-fc85-4366-a54a-174f58e77417.jpeg",
                    },
                    created_at: "2024-07-11 03:21:21",
                    updated_at: "2024-07-11 03:21:21",
                  },
                ],
              },
            ],
            max_duration: 45,
          },
          {
            id: 3,
            category_customer_id: 1,
            location_id: 1,
            name: "TENT (1) - CAMPAIGN (3)",
            start_date: "2024-07-01",
            end_date: "2024-08-31",
            start_time: "00:00:00",
            end_time: "23:00:00",
            width: "400",
            height: "400",
            days_of_week: {
              sun: "true",
              mon: "true",
              tue: "true",
              wed: "true",
              thu: "true",
              fri: "true",
              sat: "true",
            },
            status: "ON-AIR",
            created_at: "2024-07-11 02:16:59",
            updated_at: "2024-07-11 02:16:59",
            adsBlocks: [
              {
                id: 4,
                advertising_campaign_id: 3,
                block_key: "6d94f0dc-c1a6-46b6-ba37-3f10400ab62d",
                name: "BLOCK-1",
                width: "400",
                height: "400",
                position_x: "0",
                position_y: "0",
                created_at: "2024-07-11 02:33:03",
                updated_at: "2024-07-11 02:33:03",
                blockMedias: [
                  {
                    id: 1,
                    ads_block_id: 4,
                    type: "image",
                    is_use_media_in_project: true,
                    media_id: 5,
                    duration: 15,
                    attribute: {
                      objectFit: "contain",
                      path: "uploads/medias/customer_1/location_1/b9aed779-3631-472c-8741-3ef2cfef89ed.jpeg",
                    },
                    created_at: "2024-07-11 02:33:03",
                    updated_at: "2024-07-11 02:33:03",
                  },
                  {
                    id: 7,
                    ads_block_id: 4,
                    type: "running-text",
                    is_use_media_in_project: false,
                    media_id: null,
                    duration: 20,
                    attribute: {
                      text: "TENT",
                      direction: "left",
                      fontSize: "20px",
                      color: "#ffffff",
                      speed: "10",
                      fontFamily: "Chonburi",
                      backgroundColor: "#000000",
                    },
                    created_at: "2024-07-11 02:33:03",
                    updated_at: "2024-07-11 02:33:03",
                  },
                  {
                    id: 2,
                    ads_block_id: 4,
                    type: "image",
                    is_use_media_in_project: true,
                    media_id: 6,
                    duration: 15,
                    attribute: {
                      objectFit: "contain",
                      path: "uploads/medias/customer_1/location_1/65fa1b9f-083c-45d6-8835-ab4cdd0c8036.jpeg",
                    },
                    created_at: "2024-07-11 02:33:03",
                    updated_at: "2024-07-11 02:33:03",
                  },
                ],
              },
            ],
            max_duration: 50,
          },
        ],
      },
      message: "This player is already registered",
    };
    if (_.get(resp, ["status"])) {
      // find max duration
      const results = _.chain(resp)
        .get(["result", "respCampaignList"])
        .filter((item) => {
          const adsBlocks = _.get(item, ["adsBlocks"]);
          return (
            _.size(adsBlocks) > 0 &&
            _.every(adsBlocks, (block) => !_.isEmpty(block.blockMedias))
          );
        })
        .map((item) => {
          const maxDuration = _.chain(item)
            .get(["adsBlocks"])
            .map((item) => {
              const blockMedias = _.get(item, ["blockMedias"]);
              return _.sumBy(blockMedias, "duration");
            })
            .max()
            .value();
          return { ...item, max_duration: maxDuration };
        })
        .value();
      console.log("results :>> ", results);

      // setIsLoading(false);
      setIsReady(_.isEmpty(results) ? false : true);
      setCampaigns(results);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    filterCampaigns();
    filterIntervalRef.current = setInterval(filterCampaigns, 60000);

    return () => {
      clearInterval(filterIntervalRef.current);
    };
  }, [campaigns]);

  const filterCampaigns = () => {
    const now = dayjs();
    const filtered = _.filter(campaigns, (campaign) => {
      const startTime = dayjs()
        .set("hour", campaign?.start_time.split(":")[0])
        .set("minute", campaign?.start_time.split(":")[1])
        .set("second", campaign?.start_time.split(":")[2]);
      const endTime = dayjs()
        .set("hour", campaign?.end_time.split(":")[0])
        .set("minute", campaign?.end_time.split(":")[1])
        .set("second", campaign?.end_time.split(":")[2]);
      return (
        (now.isSame(startTime) || now.isAfter(startTime)) &&
        (now.isBefore(endTime) || now.isSame(endTime))
      );
    });
    console.log("now :>> ", now?.format("DD-MM-YYYY HH:mm:ss"));
    console.log("query campaigns :>> ", campaigns);
    console.log("filtered :>> ", filtered);
    setFilteredCampaigns(filtered);
  };

  useEffect(() => {
    if (_.size(filteredCampaigns) > 0) {
      const timer = setTimeout(() => {
        handleNextCampaign();
      }, _.get(filteredCampaigns[currentCampaignIndex], ["max_duration"]) * 1000);

      intervalRef.current = setInterval(() => {
        setCampaignElapsedTime((prev) => prev + 1);
      }, 1000);

      return () => {
        clearTimeout(timer);
        clearInterval(intervalRef.current);
      };
    }
  }, [currentCampaignIndex, filteredCampaigns]);

  const handleNextCampaign = () => {
    setCampaignElapsedTime(0);
    setCurrentCampaignIndex((prevIndex) => {
      const nextIndex = (prevIndex + 1) % _.size(filteredCampaigns);
      if (nextIndex === 0) {
        setPlayCampaignCount((prev) => prev + 1);
        filterCampaigns();
      }
      return nextIndex;
    });
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        {isReady ? (
          <AdsLayout
            width={_.get(currentCampaign, ["width"])}
            height={_.get(currentCampaign, ["height"])}
          >
            <div>round: {playCampaignCount}</div>

            {!_.chain(currentCampaign).get(["adsBlocks"]).isNil().value() &&
              _.chain(currentCampaign)
                .get(["adsBlocks"], [])
                .map((item, index) => {
                  return (
                    <BlockItem
                      key={index}
                      block={item}
                      playCampaignCount={playCampaignCount}
                    />
                  );
                })
                .value()}
          </AdsLayout>
        ) : (
          <InitialPlayer />
        )}
      </Container>
    </>
  );
};
